import { render, staticRenderFns } from "./ArchiveProjectGroupDialog.vue?vue&type=template&id=7f812d65&"
import script from "./ArchiveProjectGroupDialog.vue?vue&type=script&lang=ts&"
export * from "./ArchiveProjectGroupDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports